export default {
  edit (aModel) {
    this.editRelation('customers', aModel)
  },

  delete (aModel) {
    this.deleteRelation('customers', aModel)
  }
}



// WEBPACK FOOTER //
// ./src/functions/customer.js